export const VERSION = 'v1.0';
export const BASE_PATH = '/';
export const DEPLOY_URL = 'https://woodlands-dentistry-demo.azulogic.in';
